import { useState } from 'react'
import { Link } from 'react-router-dom'
import './AboutPage.css'
import PageLayout from '../components/layout/PageLayout'
import Reveal from '../components/common/Reveal'
import maharajJi1Img from '../assets/images/maharaj-ji.png'
import maharajJi2Img from '../assets/images/maharaj-ji2.png'
import { appUrl } from '@astro/config'
const CHIPS = [
  'Kundli Analysis',
  'Vastu Shastra',
  'Palmistry',
  'Numerology',
  'Vedic Remedies',
  'Gem Therapy',
]

const STATS = [
  { value: '10K+', label: 'Sessions' },
  { value: '10+', label: 'Countries' },
  { value: '15+', label: 'Years Exp.' },
]

const VALUES = [
  {
    icon: '🪔',
    title: 'Our Mission',
    body: 'To make authentic Vedic astrology accessible to all — translating ancient wisdom into practical guidance that empowers real-life decisions.',
  },
  {
    icon: '🔭',
    title: 'Our Vision',
    body: "A world where every seeker can navigate life's uncertainties with clarity, free from fear, superstition, and exploitation.",
  },
  {
    icon: '🤝',
    title: 'Integrity First',
    body: 'Honest, transparent counsel. We never promise the impossible, and every remedy is grounded in classical scripture.',
  },
  {
    icon: '📜',
    title: 'Authentic Tradition',
    body: 'Rooted in Parashari and Nadi systems passed down through generations of Vedic scholars.',
  },
  {
    icon: '🙏',
    title: 'Compassion',
    body: 'Every seeker is heard with patience and empathy — guidance is never rushed, never judged.',
  },
  {
    icon: '🔒',
    title: 'Confidentiality',
    body: 'Your birth data and personal concerns remain fully private, encrypted, and secure at all times.',
  },
]

const TIMELINE = [
  {
    year: '2011',
    title: 'First Initiation',
    body: 'Began formal study of Jyotish under revered gurus, mastering Sanskrit scriptures and planetary calculations.',
  },
  {
    year: '2015',
    title: 'First Practice Established',
    body: 'Opened doors to the public, offering Kundli analysis and Vastu consultations to a growing community of seekers.',
  },
  {
    year: '2018',
    title: 'Global Recognition',
    body: 'Honoured by leading Vedic institutions; consultations expand to seekers across 10+ countries worldwide.',
  },
  {
    year: '2021',
    title: 'The Vedic Academy',
    body: 'Launched an online academy and divine shop, making authentic teachings and energised remedies available to all.',
  },
  {
    year: '2026',
    title: 'A Complete Digital Sanctuary',
    body: 'Unveiled a unified online platform — live consultations, puja bookings, horoscopes, and a family of trusted astrologers, all in one sacred space.',
  },
]

const WHY_CHOOSE = [
  {
    icon: '✅',
    title: 'Certified & Recognised',
    body: 'Accredited by multiple national and international Vedic Jyotish bodies.',
  },
  {
    icon: '🔮',
    title: 'Precise, Personalised Readings',
    body: 'Every chart is analysed individually — never generic, never automated.',
  },
  {
    icon: '💠',
    title: 'Genuine Remedies',
    body: 'Energised gemstones and rituals prescribed only when truly needed.',
  },
  {
    icon: '💬',
    title: 'Lifelong Support',
    body: 'Follow-up guidance and a supportive community for every seeker.',
  },
]

const CREDENTIAL_STATS = [
  { value: '10K+', label: 'Sessions Delivered', offset: false },
  { value: '15+', label: 'Years of Practice', offset: true },
  { value: '10+', label: 'Countries Served', offset: false },
  { value: '4.9', label: 'Average Rating', offset: true },
]

const RECOGNITIONS = [
  'Vedic Jyotish Samiti',
  'All India Astrology Congress',
  'Bharat Jyotish Mahasangh',
  "Int'l Vedic Institute",
]

function PortraitBadge({ position, delay, icon, value, label }) {
  return (
    <div
      className="absolute z-40 animate-float hidden sm:block"
      style={{
        ...position,
        animationDelay: delay,
        borderRadius: '18px',
        padding: '11px 15px',
        background: 'linear-gradient(135deg,rgba(18,10,4,.92),rgba(28,14,5,.88))',
        backdropFilter: 'blur(22px)',
        border: '1px solid rgba(245,158,11,.28)',
        boxShadow: '0 10px 36px -6px rgba(0,0,0,.75)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div
          style={{
            width: '34px',
            height: '34px',
            borderRadius: '12px',
            background: 'linear-gradient(135deg,rgba(245,158,11,.28),rgba(245,158,11,.09))',
            border: '1px solid rgba(245,158,11,.3)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '16px',
          }}
        >
          {icon}
        </div>
        <div>
          <p className="num" style={{ fontSize: '15px', fontWeight: 900, color: '#FBBF24', lineHeight: 1 }}>
            {value}
          </p>
          <p style={{ fontSize: '7px', textTransform: 'uppercase', letterSpacing: '.16em', color: 'rgba(255,255,255,.4)', marginTop: '2px' }}>
            {label}
          </p>
        </div>
      </div>
    </div>
  )
}

export default function AboutPage() {
  const [imgFailed, setImgFailed] = useState(false)

  return (
    <PageLayout className="about-page text-astroDark antialiased overflow-x-hidden">

      {/* ── HERO / BREADCRUMB BANNER ── */}
      <header className="relative pt-30 sm:pt-32.5 lg:pt-37.5 pb-20 lg:pb-28 overflow-hidden bg-[#5A0808] text-white text-center">
        <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
          <div className="absolute top-[-20%] left-1/2 -translate-x-1/2 w-[70vw] h-[70vw] bg-cosmicRed/15 rounded-full animate-aura blur-3xl" />
          <svg
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[70%] aspect-square opacity-[0.06] text-goldPrimary animate-spin-slow"
            viewBox="0 0 200 200"
            fill="none"
            stroke="currentColor"
          >
            <circle cx="100" cy="100" r="98" strokeWidth="0.5" />
            <circle cx="100" cy="100" r="74" strokeWidth="0.5" strokeDasharray="2 4" />
            <circle cx="100" cy="100" r="50" strokeWidth="0.5" />
            <path d="M100 2v196M2 100h196" strokeWidth="0.3" />
          </svg>
        </div>
        <div className="relative z-10 max-w-3xl mx-auto px-6">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-8 h-px bg-goldPrimary/40" />
            <span className="text-[9px] uppercase font-bold tracking-[0.4em] text-goldPrimary/70 font-royal">The Vedic Seer</span>
            <span className="w-8 h-px bg-goldPrimary/40" />
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-royal text-[#FBF3E4] leading-tight">
            About{' '}
            <span className="bg-linear-to-r from-goldPrimary via-amber-300 to-goldAccent bg-clip-text text-transparent">
              Maharaj Ji
            </span>
          </h1>
          <p className="text-sm sm:text-base text-white/50 font-light mt-5 max-w-xl mx-auto leading-relaxed">
            A lifelong devotion to Jyotish Shastra — guiding seekers across the world toward clarity, prosperity, and
            spiritual alignment.
          </p>
          <nav aria-label="Breadcrumb" className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 mt-7 px-4 text-[10px] uppercase tracking-[0.2em] font-semibold text-white/40">
            <Link to="/" className="hover:text-goldPrimary transition-colors">Home</Link>
            <span className="text-goldPrimary/50">/</span>
            <span className="text-goldPrimary">About</span>
          </nav>
        </div>
      </header>

      {/* ── MEET MAHARAJ JI ── */}
      <section
        className="relative py-20 lg:py-28 md:px-10 overflow-hidden"
        style={{ background: 'linear-gradient(180deg,#0B0806 0%,#0f0a07 50%,#0B0806 100%)' }}
      >
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden="true">
          <div
            className="absolute -top-32 -left-32 w-[55vw] max-w-160 h-[55vw] max-h-160 rounded-full"
            style={{ background: 'radial-gradient(circle,rgba(120,53,15,.18) 0%,transparent 70%)', filter: 'blur(80px)' }}
          />
          <div
            className="absolute -bottom-32 -right-32 w-[45vw] max-w-135 h-[45vw] max-h-135 rounded-full"
            style={{ background: 'radial-gradient(circle,rgba(161,88,10,.12) 0%,transparent 70%)', filter: 'blur(90px)' }}
          />
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
            {/* Portrait */}
            <Reveal className="lg:col-span-5 flex justify-center items-start">
              <div className="relative select-none group">
                <div
                  className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                  aria-hidden="true"
                  style={{ width: '118%', height: '118%', zIndex: 0 }}
                >
                  <svg
                    viewBox="0 0 200 200"
                    fill="none"
                    stroke="currentColor"
                    className="w-full h-full animate-spin-slow"
                    style={{ color: 'rgba(245,158,11,0.18)' }}
                  >
                    <circle cx="100" cy="100" r="98" strokeWidth="0.6" />
                    <circle cx="100" cy="100" r="82" strokeWidth="0.4" strokeDasharray="2 5" />
                    <path d="M100 2v196M2 100h196" strokeWidth="0.3" />
                  </svg>
                </div>
                <div
                  className="relative z-10 rounded-[28px] overflow-hidden border border-goldPrimary/20 shadow-2xl"
                  style={{ boxShadow: '0 30px 80px -30px rgba(0,0,0,.8)' }}
                >
                  <img
                    src={imgFailed ? maharajJi2Img : maharajJi1Img}
                    alt="Astrologer Raju Maharaj Ji"
                    className="w-full max-w-95 object-cover"
                    onError={() => setImgFailed(true)}
                  />
                </div>
                <PortraitBadge position={{ bottom: '14%', right: '-22px' }} icon="🌍" value="10+" label="Countries" />
                <PortraitBadge position={{ top: '10%', left: '-24px' }} delay="-2s" icon="⭐" value="4.9" label="Avg Rating" />
              </div>
            </Reveal>

            {/* Content */}
            <Reveal className="lg:col-span-7 space-y-6">
              <div className="flex items-center gap-3">
                <div className="w-7 h-px" style={{ background: 'rgba(245,158,11,.45)' }} />
                <span className="font-royal text-[9px] uppercase font-bold tracking-[.45em]" style={{ color: 'rgba(245,158,11,.58)' }}>
                  Jyotish Acharya · Palmist · Vastu Consultant
                </span>
              </div>
              <h2 className="font-royal text-4xl lg:text-[48px] font-normal text-white leading-tight">
                A Lifetime Devoted to{' '}
                <span className="bg-linear-to-r from-goldPrimary via-amber-300 to-goldAccent bg-clip-text text-transparent">
                  Sacred Wisdom
                </span>
              </h2>
              <div className="flex items-center gap-4">
                <div className="flex-1 max-w-22.5 h-px" style={{ background: 'linear-gradient(90deg,rgba(245,158,11,.35),transparent)' }} />
                <span className="font-royal text-sm" style={{ color: 'rgba(245,158,11,.38)' }}>ॐ</span>
                <div className="flex-1 max-w-22.5 h-px" style={{ background: 'linear-gradient(90deg,transparent,rgba(245,158,11,.35))' }} />
              </div>
              <p className="text-[14px] leading-[1.9]" style={{ color: 'rgba(255,255,255,.48)', fontWeight: 300 }}>
                Trained in the ancient traditions of Jyotish Shastra, Maharaj Ji blends classical Parashari methods, Nadi
                astrology, and deep intuitive wisdom to deliver precise, life-changing guidance to seekers across 10+
                countries. For over two and a half decades, his counsel has illuminated paths in career, marriage,
                health, and spiritual growth.
              </p>
              <p className="text-[14px] leading-[1.9]" style={{ color: 'rgba(255,255,255,.42)', fontWeight: 300 }}>
                Born into a lineage of Vedic scholars, his earliest years were spent immersed in Sanskrit scriptures and
                the study of planetary movements. Today his mission is simple — to make authentic Vedic knowledge
                accessible, practical, and free of superstition for the modern seeker.
              </p>

              {/* Stats */}
              <div className="flex items-stretch gap-0 py-1">
                {STATS.map((stat, i) => (
                  <div key={stat.label} className="contents">
                    <div className={`${i === 0 ? 'pr-7' : i === STATS.length - 1 ? 'pl-7' : 'px-7'} text-center`}>
                      <p className="num text-3xl font-bold text-goldPrimary leading-none">{stat.value}</p>
                      <p className="text-[8px] uppercase tracking-[.28em] mt-1.5 font-semibold" style={{ color: 'rgba(255,255,255,.3)' }}>
                        {stat.label}
                      </p>
                    </div>
                    {i < STATS.length - 1 && <div className="w-px shrink-0" style={{ background: 'rgba(255,255,255,.08)' }} />}
                  </div>
                ))}
              </div>

              {/* Chips */}
              <div className="flex flex-wrap gap-2">
                {CHIPS.map((chip) => (
                  <span
                    key={chip}
                    className="about-chip px-3 py-1.5 rounded-full border text-[9px] font-semibold tracking-wider uppercase cursor-default"
                    style={{ borderColor: 'rgba(245,158,11,.2)', color: 'rgba(245,158,11,.72)' }}
                  >
                    {chip}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 pt-2">
                <a
                  href={appUrl('shop', 'book-maharaj-ji')}
                  className="shine-btn bg-linear-to-r from-goldAccent to-goldPrimary text-astroDark font-bold text-[11px] uppercase tracking-[.22em] px-8 py-3.5 rounded-full shadow-xl transition-all duration-300 hover:scale-105"
                >
                  Book A Session
                </a>
                <a
                  href="https://www.youtube.com/@astrologerrajumaharaj"
                  target='_blank'
                  className="flex items-center gap-2.5 group text-white/40 hover:text-goldPrimary transition-colors"
                >
                  <span className="w-8 h-8 rounded-full flex items-center justify-center border border-white/12 group-hover:border-goldPrimary/30 transition-colors">
                    <svg className="w-3 h-3 ml-0.5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </span>
                  <span className="text-[10px] uppercase tracking-widest font-semibold">Watch Story</span>
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* ── MISSION & VISION ── */}
      <section className="relative py-20 lg:py-28 md:px-10" style={{ background: '#FDFAF5' }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <Reveal className="text-center max-w-2xl mx-auto mb-14">
            <span className="font-royal text-[9px] uppercase font-bold tracking-[.45em] text-amber-700/70">Our Purpose</span>
            <h2 className="text-3xl lg:text-[40px] text-astroDark mt-3">Mission &amp; Guiding Values</h2>
            <p className="text-sm text-stone-500 font-light mt-4 leading-relaxed">
              Every reading, remedy, and lesson we offer is rooted in authenticity, compassion, and the timeless science
              of the Vedas.
            </p>
          </Reveal>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {VALUES.map((v, i) => (
              <Reveal key={v.title} className="val-card p-7" style={{ transitionDelay: `${(i % 3) * 0.05}s` }}>
                <div className="w-12 h-12 rounded-2xl bg-amber-50 flex items-center justify-center text-2xl mb-4">{v.icon}</div>
                <h3 className="text-lg text-astroDark">{v.title}</h3>
                <p className="text-[13px] text-stone-500 font-light leading-relaxed mt-2">{v.body}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* ── JOURNEY TIMELINE ── */}
      <section className="relative py-20 lg:py-28 md:px-10 overflow-hidden" style={{ background: 'linear-gradient(180deg,#160F0A,#0B0806)' }}>
        <div className="absolute inset-0 pointer-events-none" aria-hidden="true">
          <div className="absolute top-1/4 right-[-10%] w-[40vw] h-[40vw] rounded-full bg-goldGlow/10 blur-3xl" />
        </div>
        <div className="max-w-5xl mx-auto px-6 lg:px-12 relative z-10">
          <Reveal className="text-center mb-14">
            <span className="font-royal text-[9px] uppercase font-bold tracking-[.45em] text-goldPrimary/60">The Journey</span>
            <h2 className="text-3xl lg:text-[40px] text-white mt-3">A Path Written in the Stars</h2>
          </Reveal>
          <div className="relative">
            <div className="absolute left-4 sm:left-1/2 top-0 bottom-0 w-px bg-linear-to-b from-goldPrimary/40 via-goldPrimary/20 to-transparent sm:-translate-x-1/2" />
            <div className="space-y-10">
              {TIMELINE.map((item, i) => {
                const leftSide = i % 2 === 0
                return (
                  <Reveal key={item.year} className="relative flex flex-col sm:flex-row items-start sm:items-center gap-4">
                    {leftSide ? (
                      <>
                        <div className="sm:w-1/2 sm:pr-12 sm:text-right order-2 sm:order-1 pl-12 sm:pl-0">
                          <p className="num text-goldPrimary font-bold text-lg">{item.year}</p>
                          <h3 className="text-white text-lg mt-1">{item.title}</h3>
                          <p className="text-[13px] text-white/45 font-light mt-1.5 leading-relaxed">{item.body}</p>
                        </div>
                        <div className="absolute left-4 sm:left-1/2 sm:-translate-x-1/2 w-4 h-4 rounded-full bg-goldPrimary border-4 border-astroDark shadow-[0_0_14px_rgba(245,158,11,.5)] order-1" />
                        <div className="sm:w-1/2 order-3" />
                      </>
                    ) : (
                      <>
                        <div className="sm:w-1/2 order-3 sm:order-1" />
                        <div className="absolute left-4 sm:left-1/2 sm:-translate-x-1/2 w-4 h-4 rounded-full bg-goldPrimary border-4 border-astroDark shadow-[0_0_14px_rgba(245,158,11,.5)] order-1" />
                        <div className="sm:w-1/2 sm:pl-12 order-2 pl-12">
                          <p className="num text-goldPrimary font-bold text-lg">{item.year}</p>
                          <h3 className="text-white text-lg mt-1">{item.title}</h3>
                          <p className="text-[13px] text-white/45 font-light mt-1.5 leading-relaxed">{item.body}</p>
                        </div>
                      </>
                    )}
                  </Reveal>
                )
              })}
            </div>
          </div>
        </div>
      </section>

      {/* ── WHY CHOOSE / CREDENTIALS ── */}
      <section className="relative py-20 lg:py-28 md:px-10" style={{ background: '#FDFAF5' }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <Reveal>
              <span className="font-royal text-[9px] uppercase font-bold tracking-[.45em] text-amber-700/70">Why Seekers Trust Us</span>
              <h2 className="text-3xl lg:text-[40px] text-astroDark mt-3 leading-tight">Authentic Guidance You Can Rely On</h2>
              <p className="text-sm text-stone-500 font-light mt-4 leading-relaxed">
                Decades of disciplined study, thousands of accurate predictions, and an unwavering commitment to ethical
                practice set our mission apart.
              </p>
              <div className="space-y-4 mt-7">
                {WHY_CHOOSE.map((item) => (
                  <div key={item.title} className="flex items-start gap-4">
                    <span className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center text-lg shrink-0">{item.icon}</span>
                    <div>
                      <h4 className="text-sm font-semibold text-astroDark">{item.title}</h4>
                      <p className="text-[13px] text-stone-500 font-light mt-0.5">{item.body}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Reveal>
            <Reveal className="grid grid-cols-2 gap-5">
              {CREDENTIAL_STATS.map((stat) => (
                <div key={stat.label} className={`val-card p-6 text-center${stat.offset ? ' mt-8' : ''}`}>
                  <p className="num text-4xl font-bold text-goldAccent">{stat.value}</p>
                  <p className="text-[11px] uppercase tracking-wider text-stone-500 font-semibold mt-2">{stat.label}</p>
                </div>
              ))}
            </Reveal>
          </div>

          {/* Recognitions */}
          <Reveal className="mt-16 pt-10 border-t border-stone-200">
            <p className="text-center text-[9px] uppercase tracking-[.3em] font-semibold text-stone-400 mb-6">Recognised &amp; Accredited By</p>
            <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-center">
              {RECOGNITIONS.map((name, i) => (
                <div key={name} className="contents">
                  <span className="text-xs uppercase tracking-[.2em] text-stone-500 font-semibold">{name}</span>
                  {i < RECOGNITIONS.length - 1 && <span className="text-goldPrimary/40 text-[8px]">✦</span>}
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* ── CTA BAND ── */}
      <section
        className="relative py-16 lg:py-20 overflow-hidden"
        style={{ background: 'radial-gradient(ellipse 120% 100% at 50% 0%,#C2710C 0%,#92400E 30%,#4A1A05 65%,#1A0803 100%)' }}
      >
        <div className="absolute inset-0 pointer-events-none opacity-10" aria-hidden="true">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[200px] font-royal text-white select-none">ॐ</div>
        </div>
        <div className="max-w-3xl mx-auto px-6 text-center relative z-10">
          <h2 className="text-3xl lg:text-[42px] text-white leading-tight">Ready to Discover What the Stars Hold?</h2>
          <p className="text-sm text-white/70 font-light mt-4 max-w-xl mx-auto">
            Book a personal consultation with Maharaj Ji and take the first step toward clarity and alignment.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <a
              href={appUrl('jyotish', 'consultations')}
              className="shine-btn bg-white text-astroDark font-bold text-[11px] uppercase tracking-[.22em] px-8 py-4 rounded-full shadow-xl transition-transform hover:-translate-y-0.5"
            >
              Book Consultation
            </a>
            <Link
              to="/login"
              className="border border-white/40 hover:border-white text-white font-semibold text-[11px] uppercase tracking-[.22em] px-8 py-4 rounded-full transition-all hover:bg-white/10"
            >
              Create Free Account
            </Link>
          </div>
        </div>
      </section>

    </PageLayout>
  )
}
